import { render, staticRenderFns } from "./Soil.vue?vue&type=template&id=c1a55fba&"
import script from "./Soil.vue?vue&type=script&lang=js&"
export * from "./Soil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports